import * as React from "react";
import { t } from "../../translations";
import { darkBackgroundColor } from "../../constants";

export const IframeElement = ({
  title,
  fileUrl,
  iframeWidth,
  iframeHeight,
  showDownloadLink,
  altFileUrl,
  backgroundColor = darkBackgroundColor,
  locale,
}) => {
  const sizeRegex = /^[0-9]+(pt|px|%)$/;

  const iframeStyle = {
    height: sizeRegex.test(iframeHeight) ? iframeHeight : "800px",
  };

  if (sizeRegex.test(iframeWidth)) {
    iframeStyle.width = iframeWidth;
    iframeStyle.margin = "auto";
  }

  return (
    <div className={`${backgroundColor}`}>
      <div className="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-extrabold text-gray-900 text-center mb-12">
          {title}
        </h2>

        {showDownloadLink && (
          <a
            className="block my-4 text-action underline font-medium"
            href={altFileUrl || fileUrl}
            download
          >
            {t(locale, "iframe-element.download")}
          </a>
        )}
        <iframe title={title} src={fileUrl} width="100%" style={iframeStyle} />
      </div>
    </div>
  );
};
